import { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import { Dispatch } from 'react'

import type { PageLogger } from '../../../../../bi/mfi'
import { BusinessTermService } from '../../../../reusable/Category/api/BusinessTermService'
import { SearchAction, SearchActionType, SearchStateCategory } from '../types'

interface SelectCategoryParams {
  dispatch: Dispatch<SearchAction>
  businessTerm: BusinessTerm
  businessTermService: BusinessTermService
  questionKey: string
  pageLogger: PageLogger
  index: number
}

export const selectCategory = async ({
  businessTerm,
  businessTermService,
  dispatch,
  questionKey,
  pageLogger,
  index,
}: SelectCategoryParams) => {
  const businessSegmentId = businessTerm.businessTermId
    ? await businessTermService.getBusinessSegmentIdByTermId(businessTerm.businessTermId || '')
    : undefined

  const category: SearchStateCategory = {
    businessTerm,
    businessSegmentId,
    index,
  }

  void pageLogger.clickAnswer({
    questionKey,
    buttonName: businessTerm.displayName || '',
    position: index + 1,
    suggestedOption: false,
  })

  dispatch({ type: SearchActionType.SEARCH_SELECT_CATEGORY, category })
}
